import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import axios from '../../util/Axios';

export function RemoveFromDataSet({ testId, dataSetId, dataSetName, handleClose, open }) {
  function handleRemove() {
    axios(`dataSets/${dataSetId}/${testId}`, {
      method: 'DELETE',
    }).then((resp) => handleClose());
  }

  return (
    <>
      <Dialog open={open}>
        <DialogTitle>Remove</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Remove test {testId} from {dataSetName}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleRemove}>
            Remove
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
